import { Businesses } from '@prisma/client';
import { CUSTOMER_WEB_URL } from '../../constants/global';
import { LoadedUser } from '../../interfaces';
import { FlashbookDesign } from '../../types/flashbooks';
import { isUserAdminOrManager } from '../../utils/global/helper';

export const getRefImagesFromFlashDesign = (
  flashDesign: Pick<FlashbookDesign, 'images'> | undefined,
) => {
  if (!flashDesign?.images?.length) return [];
  const { images } = flashDesign;
  return [...images]
    .sort((a, b) => {
      if (a.isCoverPhoto && !b.isCoverPhoto) return -1;
      if (!a.isCoverPhoto && b.isCoverPhoto) return 1;
      return a.sortOrder - b.sortOrder;
    })
    .map(image => image.url);
};

export const getFlashbookUrl = (artistPath: string | undefined) =>
  artistPath ? `${CUSTOMER_WEB_URL}/artist/${artistPath}/flash` : '';

export const getFlashDesignUrl = (
  artistPath: string | undefined,
  flashDesignExternalId: string,
) => {
  const flashbookPath = getFlashbookUrl(artistPath);
  if (!flashbookPath) return '';

  return `${flashbookPath}/${flashDesignExternalId}`;
};

export const getShopFlashbookUrl = (
  business: Pick<Businesses, 'urlPath'> | null | undefined,
) =>
  business?.urlPath ? `${CUSTOMER_WEB_URL}/shop/${business.urlPath}/flash` : '';

export const getShopFlashDesignUrl = (
  business: Pick<Businesses, 'urlPath'> | null | undefined,
  flashDesignExternalId: string,
) => {
  const shopFlashUrl = getShopFlashbookUrl(business);
  if (!shopFlashUrl) return '';

  return `${shopFlashUrl}/${flashDesignExternalId}`;
};

export const getAppointmentFlashDesignUrl = (
  flashDesign: Pick<FlashbookDesign, 'externalId' | 'flashbook'>,
  employee: { urlPath?: string | null } | null | undefined,
) => {
  if (flashDesign.flashbook?.business) {
    return getShopFlashDesignUrl(
      flashDesign.flashbook.business,
      flashDesign.externalId,
    );
  }
  return getFlashDesignUrl(
    employee?.urlPath ?? undefined,
    flashDesign.externalId,
  );
};

export const userHasAccessToShopFlash = (user: LoadedUser) =>
  user?.business?.type === 'STUDIO' && isUserAdminOrManager(user);
